import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';

type UseExternalFeatureQueryProps = {
  sourceId: string;
  featureId?: string | number;
};

type ExternalFeature<T> = {
  attributes: T;
  dateCreated: string;
  dateModified: string;
};

type UseExternalFeatureQuery<T> = Omit<
  UseQueryResult<ExternalFeature<T>, Error>,
  'data'
> & {
  externalFeature?: ExternalFeature<T>;
};

export const useExternalFeatureQuery = <T = Record<string, unknown>>(
  props: UseExternalFeatureQueryProps,
): UseExternalFeatureQuery<T> => {
  const { sourceId, featureId } = props;

  const { data: externalFeature, ...results } = useQuery({
    queryKey: ['external-feature', sourceId, featureId],
    queryFn: async () => {
      const response = await API.get<ExternalFeature<T>>(
        `feature_layer_mirrors/feature/${featureId}`,
      );
      return response.data;
    },
    enabled: Boolean(featureId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return { ...results, externalFeature };
};
